var exports = {
  "i": "xaee3c4fa--ea7a61--wrapper",
};

module.exports = exports;
